module.exports = __webpack_public_path__ + "img/ep-L.87c8676a.jpg";